import { StarIcon } from "lucide-react";
import { OPINIONES } from "../data/content";
export function Opiniones() {
  return <section className="px-5 pt-10" data-id="element-172" data-mp="93wgvkbbx8ct">
      <div className="space-y-3" data-id="element-173" data-mp="92ureatkgjbk">
        {OPINIONES.map(o => <div key={o.name} className="rounded-2xl border border-blue-100 bg-white/90 p-4 shadow-sm backdrop-blur" data-id="element-174" data-mp="mtgcm66ht5cm">
            <div className="flex gap-0.5" data-id="element-175" data-mp="hxrbhyetrge7">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} size={14} className="fill-yellow-400 text-yellow-400" data-id="element-176" data-mp="3qd1h3ghxb3qq" data-mpi={i} />)}
            </div>
            <p className="mt-2 text-sm leading-relaxed text-gray-700" data-id="element-177" data-mp="41nkedz8zo5y">
              “{o.text}”
            </p>
            <p className="mt-2 text-xs font-semibold text-blue-950" data-id="element-178" data-mp="1fj6rihfy8b9s">
              {o.name} · {o.city}
            </p>
          </div>)}
      </div>

      <p className="mt-10 text-center text-2xl font-black text-blue-950" data-id="element-179" data-mp="1ajkfgbbux12k">
        El único límite, es tu mente
      </p>
    </section>;
}